import { RouteObject } from "react-router-dom";
import { SURVEY_EDITOR_PATH, SurveyEditorPage } from "./pages/survey-editor";
import { SurveyListPage, SURVEY_LIST_PATH } from "./pages/survey-list";
import { SURVEY_SCALE_PATH, SurveyScalePage } from "./pages/survey-scale";
import { MySurveysPage, MY_SURVEYS_PATH } from "./pages/my-surveys";
import { SURVEY_PATH, SurveyPage } from "./pages/survey";
import {
  SurveyResultByIdPage,
  SURVEY_RESULT_BY_ID_PATH,
} from "./pages/my-survey-result";
import { SURVEY_SCALES_PATH, SurveyScalesPage } from "./pages/survey-scales";
import { SurveyModuleOr404 } from "@/shared/modules";
import {
  SURVEY_EDITOR_PARTICIPANT_RESULT_PATH,
  SurveyEditorParticipantResult,
} from "./pages/survey-editor-participant-result";
import { RestrictSurveyEditor } from "./shared/access/restrict-survey-editor";
import { TEST_PATH, TestPage } from "./pages/test";
import { PASS_TEST_PATH, PassTestPage } from "./pages/pass-test";
import {
  TEST_PARTICIPANT_RESULT_PATH,
  TestParticipantResultPage,
} from "./pages/test-participant-result";
import {
  ASSESSMENT_PATH,
  AssessmentPage,
} from "@/modules/survey/pages/assessment";

export const surveys: RouteObject[] = [
  {
    element: (
      <RestrictSurveyEditor>
        <SurveyListPage />
      </RestrictSurveyEditor>
    ),
    path: SURVEY_LIST_PATH,
  },
  {
    element: (
      <RestrictSurveyEditor>
        <SurveyEditorPage />
      </RestrictSurveyEditor>
    ),
    path: SURVEY_EDITOR_PATH,
  },
  {
    element: (
      <RestrictSurveyEditor>
        <SurveyEditorParticipantResult />
      </RestrictSurveyEditor>
    ),
    path: SURVEY_EDITOR_PARTICIPANT_RESULT_PATH,
  },
  {
    element: (
      <RestrictSurveyEditor>
        <SurveyScalesPage />
      </RestrictSurveyEditor>
    ),
    path: SURVEY_SCALES_PATH,
  },
  {
    element: (
      <RestrictSurveyEditor>
        <SurveyScalePage />
      </RestrictSurveyEditor>
    ),
    path: SURVEY_SCALE_PATH,
  },
  {
    element: <MySurveysPage />,
    path: MY_SURVEYS_PATH,
  },
  {
    element: <SurveyPage />,
    path: SURVEY_PATH,
  },
  {
    element: <SurveyResultByIdPage />,
    path: SURVEY_RESULT_BY_ID_PATH,
  },
  {
    element: <AssessmentPage />,
    path: ASSESSMENT_PATH,
  },
  {
    element: (
      <RestrictSurveyEditor>
        <TestPage />
      </RestrictSurveyEditor>
    ),
    path: TEST_PATH,
  },
  {
    element: (
      <RestrictSurveyEditor>
        <TestParticipantResultPage />
      </RestrictSurveyEditor>
    ),
    path: TEST_PARTICIPANT_RESULT_PATH,
  },
  {
    element: <PassTestPage />,
    path: PASS_TEST_PATH,
  },
].map((route) => {
  route.element = <SurveyModuleOr404>{route.element}</SurveyModuleOr404>;

  return route;
});
